import React, { useEffect } from "react";

import { Typography } from "@mui/material";
import { Card, CardContent, Stack } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { useActionHook } from "hooks";
import { useCorrelationMatrixSettingsSelector, usePortfolioConstructionActions } from "store";

import { CorrelationMatrix } from "./Correlation-matrix/CorrelationMatrix";

interface Props {
  investorId: number;
}

export const Correlation: React.FC<Props> = ({ investorId }) => {
  const settings = useCorrelationMatrixSettingsSelector();
  const { getCorrelationDataAction } = usePortfolioConstructionActions();

  const {
    action: getCorrelationData,
    data: correlationData,
    loading: correlationLoading
  } = useActionHook(getCorrelationDataAction);

  useEffect(() => {
    getCorrelationData({ investor_id: investorId, ...settings });
  }, [investorId, settings]);

  return (
    <Stack gap="20px">
      {/* Temporary disabled views */}
      {/* <Stack direction="row" alignItems="center" gap="8px" sx={{ bgcolor: "#fff", borderRadius: "8px", p: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#0a3142" }}>
              Views
            </Typography>
            <Chip
              label="Symmetrical view"
              variant={selectedView === "symmetrical" ? "filled" : "outlined"}
              onClick={() => setSelectedView("symmetrical")}
              sx={{
                color: "#071F35",
                fontSize: "12px",
                padding: "4px 8px",
                height: "24px",
                ...(selectedView === "symmetrical" && {
                  backgroundColor: "#c3c9cf !important"
                })
              }}
            />
            <Chip
              label="Custom view"
              variant={selectedView === "custom" ? "filled" : "outlined"}
              onClick={() => setSelectedView("custom")}
              sx={{
                color: "#071F35",
                fontSize: "12px",
                padding: "4px 8px",
                height: "24px",
                ...(selectedView === "custom" && {
                  backgroundColor: "#c3c9cf !important"
                })
              }}
            />
          </Stack> */}

      {/* Correlation Matrix Card */}
      <Card sx={{ boxShadow: "0 1px 2px 0 #1212171a", borderRadius: "8px", minHeight: 300 }}>
        <AsyncContentMui isLoading={correlationLoading}>
          <CardContent sx={{ padding: "16px" }}>
            {correlationData ? (
              <CorrelationMatrix data={correlationData} investorId={investorId} />
            ) : (
              <Stack sx={{ alignItems: "center", justifyContent: "center", py: "60px" }}>
                <Typography variant="h6" sx={{ color: "#496682", mb: "10px" }}>
                  Correlation Analysis
                </Typography>
                <Typography sx={{ color: "#5d7782", textAlign: "center", maxWidth: "400px" }}>
                  This feature is coming soon. Here you&apos;ll be able to analyze correlations between different
                  investments and assets in the portfolio.
                </Typography>
              </Stack>
            )}
          </CardContent>
        </AsyncContentMui>
      </Card>
    </Stack>
  );
};
